<template>
    <div>
        <pc-checkbox
            v-model="showThousandSeparators"
            v-bind:label="thousandSeparatorsLabel"
            switch
            show-help
            data-test-role="show-thousand-separators"
            v-bind:disabled="disableAllFields"
            v-on:help-clicked="toggleThousandSeparatorsHelp" />
        <pc-alert
            v-model:shown="showThousandSeparatorsHelp"
            class="mt-3 mb-0">
            {{ thousandSeparatorsHelptext }}
        </pc-alert>
    </div>
</template>

<script>
    import { deepClone } from "Util/util";
    import { KEYS, NAMESPACE } from "./i18n/editNumericSettings.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        props: {
            modelValue: { type: Object, required: true },
            disableAllFields: { type: Boolean, required: false, default: false }
        },
        emits: ["update:modelValue"],
        data() {
            return {
                showThousandSeparatorsHelp: false
            };
        },
        computed: {
            showThousandSeparators: {
                get() {
                    return this.modelValue.showThousandSeparators;
                },
                set(value) {
                    this.updateValue("showThousandSeparators", value);
                }
            },
            ...mapI18n(
                {
                    [KEYS.thousandSeparatorsHelptext]: KEYS.thousandSeparatorsHelptext,
                    [KEYS.thousandSeparatorsLabel]: KEYS.thousandSeparatorsLabel
                },
                NAMESPACE
            )
        },
        methods: {
            toggleThousandSeparatorsHelp() {
                this.showThousandSeparatorsHelp = !this.showThousandSeparatorsHelp;
            },
            updateValue(property, data) {
                const value = deepClone(this.modelValue);
                value[property] = data;
                this.$emit("update:modelValue", value);
            }
        }
    };
</script>
